import {
  float,
  Fn,
  fract,
  min,
  positionWorld,
  smoothstep,
  vec2,
  vec4,
} from "three/tsl"
import * as THREE from "three/webgpu"

export const gridPattern = Fn(
  ({
    color,
    size,
  }: {
    color: THREE.UniformNode<THREE.Color>
    size: THREE.UniformNode<number>
  }) => {
    const worldPos = positionWorld

    const patternCoords = vec2(worldPos.x, worldPos.y)

    const gridCell = patternCoords.div(size)
    const cellLocal = fract(gridCell)

    // Create grid lines at cell boundaries (0 and 1)
    const lineWidth = 0.1
    const nearEdgeX = min(cellLocal.x, cellLocal.x).oneMinus()
    const nearEdgeY = min(cellLocal.y, cellLocal.y).oneMinus()

    const gridX = smoothstep(float(0), lineWidth, nearEdgeX).oneMinus()
    const gridY = smoothstep(float(0), lineWidth, nearEdgeY).oneMinus()

    // Combine horizontal and vertical lines
    const gridMask = min(float(1), gridX.add(gridY))

    return vec4(color, gridMask)
  },
)
